import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Location } from 'history';
import { SFTimelineItem } from 'sfui';
import { Tour, TourContext, TourStepOptions } from 'ui-smartforce-settings';
import { isReportEditable } from '../../../../Helpers';
import { ReportHistoryItem } from '../ReportHistory';

export interface UseReportHistoryProps {
  items: ReportHistoryItem[];
  isAmendDisabled: boolean;
  reportStatus?: string;
  onItemClick: (item: ReportHistoryItem, index: number) => void;
  onAmend: () => void;
}

export interface UseReportHistoryReturnType {
  location: Location;
  tour: Tour | undefined;
  tourStep: number;
  onTourNext: (options?: TourStepOptions | undefined) => void;
  onAmendClick: React.MouseEventHandler<HTMLButtonElement>;
  onTimelineItemClick: (timelineItem: SFTimelineItem, index: number) => void;
  isAmendButtonDisabled: boolean;
}

export const useReportHistory = ({
  items,
  isAmendDisabled,
  reportStatus,
  onAmend,
  onItemClick
}: UseReportHistoryProps): UseReportHistoryReturnType => {
  const location = useLocation();
  const { tour, step: tourStep, onNext: onTourNext } = useContext(TourContext);

  const onAmendClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    onAmend();
  };

  const onTimelineItemClick = (
    _timelineItem: SFTimelineItem,
    index: number
  ) => {
    onItemClick(items[index], index);
  };

  const isAmendButtonDisabled: boolean =
    isAmendDisabled || !isReportEditable(reportStatus);

  return {
    location,
    tour,
    tourStep,
    onTourNext,
    onAmendClick,
    onTimelineItemClick,
    isAmendButtonDisabled
  };
};
